export default function Hero() {
  return (
    <section id="hero" className="relative pt-[72px] min-h-[600px] md:min-h-[680px] flex items-center bg-gradient-to-br from-background-50 via-background-100/60 to-primary-50/40">
      <div className="w-full px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-5">
              <i className="ri-flashlight-line text-base w-4 h-4 flex items-center justify-center"></i>
              每日更新 · 极速播放 · 高清不缓冲
            </p>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              桔子影视<span className="text-primary-500"> · </span>热播剧高清免费在线看
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 font-heading mb-6">
              追剧不等待，全集随心看
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              桔子影视电视剧大全持续收录最新热播国产剧、韩剧、美剧、日剧及海外剧集高清全集资源。
              平台每日同步更新，无需下载、无需付费，打开即看。无论是古装大戏、都市情感、悬疑探案还是青春偶像，
              您想追的剧这里全都有。极速加载引擎确保播放流畅，多线路智能切换告别卡顿，让每一次追剧都成为一种享受。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-fire-line text-accent-600 text-base w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <p className="text-lg font-bold text-foreground-900 whitespace-nowrap">30+ 部/日</p>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">内容更新</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-4k-line text-primary-600 text-base w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <p className="text-lg font-bold text-foreground-900 whitespace-nowrap">4K 超清</p>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">多画质可选</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-shield-check-line text-secondary-600 text-base w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <p className="text-lg font-bold text-foreground-900 whitespace-nowrap">完全免费</p>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">无需付费</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg w-5 h-5 flex items-center justify-center"></i>
                开始追剧
              </a>
              <a
                href="#carousel"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-background-50 text-foreground-700 font-medium rounded-lg border border-background-300/60 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
                浏览专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20gold%20toned%20cinematic%20abstract%20background%20with%20soft%20curved%20geometric%20shapes%20and%20glowing%20light%20rays%2C%20modern%20streaming%20entertainment%20atmosphere%2C%20smooth%20gradients%2C%20minimalist%20elegant%20design%2C%20film%20reel%20motif%20in%20subtle%20details%2C%20dark%20warm%20accents%2C%20premium%20streaming%20platform%20visual%20identity%2C%208k%20artistic%20render%20with%20rich%20texture%20and%20depth&width=800&height=600&seq=juzi-hero-main&orientation=landscape"
                alt="桔子影视 - 热播剧高清免费在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3">
                <span className="px-3 py-1.5 rounded-full bg-background-50/90 text-primary-700 text-xs font-semibold backdrop-blur-sm whitespace-nowrap">热播中</span>
                <span className="text-background-50/90 text-xs backdrop-blur-sm">每日更新 · 全网同步</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}